<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'flowNo'" :required="isRequired('flowNo')" v-model="formData.flowNo" :rules="getRules('flowNo')" label="编号" input-align="right" readonly/>
        <van-field v-f-show="'dcr'" v-model="formData.dcr" :required="isRequired('dcr')" name="flowName" label="订餐人" placeholder="订餐人" input-align="right" :rules="getRules('dcr')">
          <template #input>
            <view-item @click.native="isShowPopup(deptUserTreeAll,'dcr')" :treeData="deptUserTreeAll.data" :value="formData.dcr" placeholder="请选择订餐人"/>
            <van-popup position="bottom" v-model="deptUserTreeAll.show">
              <van-nav-bar title="选择订餐人" left-text="取消" right-text="确定" @click-left="deptUserTreeAll.show = false" @click-right="handlePopupSubmit"/>
              <van-search v-model="deptUserTreeAll.filterText" @input="treeSearch($event, $refs.tree)" clearable shape="round"/>
              <div style="overflow-y: auto" class="h-vh-50">
                <div class="p-10">
                  <el-tree ref="tree" @check-change="singleChoice($event,$refs.tree)" node-key="uuid" check-strictly :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
                </div>
              </div>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'lxfs'" v-model="formData.lxfs" :readonly="isDisabled('lxfs')" :required="isRequired('lxfs')" :rules="getRules('lxfs')" name="lxfs" maxlength="50" autosize label="联系方式" placeholder="请输入联系方式" input-align="right"/>
        <van-field v-f-show="'yclx'" v-model="formData.yclx" center input-align="right" :required="isRequired('yclx')" name="yclx" :rules="getRules('yclx')" label="用餐时间" placeholder="用餐时间">
          <template #input>
            <view-item v-if="isDisabled('yclx')" :value="formData.yclx" placeholder="请选择用餐时间"/>
            <van-radio-group v-else v-model="formData.yclx" direction="horizontal">
              <van-radio name="午餐">午餐</van-radio>
              <van-radio name="晚餐">晚餐</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'ycrq'" v-model="formData.ycrq" :required="isRequired('ycrq')" name="ycrq" label="用餐日期" placeholder="用餐日期" input-align="right" :rules="getRules('ycrq')">
          <template #input>
            <view-item @click.native="isShowPopup(ycrq,'ycrq')" :value="formData.ycrq" placeholder="请选择用餐日期"/>
            <van-calendar v-model="ycrq.show" ref="ycrq" :show-confirm="false" title="选择用餐日期" @confirm="ycrqConfirm" :min-date="ycrq.minDate" :max-date="ycrq.maxDate"></van-calendar>
          </template>
        </van-field>
        <van-field v-f-show="'ycdd'" :value="formData.ycdd[0]" :required="isRequired('ycdd')" name="ycdd" label="用餐地点" placeholder="用餐地点" input-align="right" :rules="getRules('ycdd')">
          <template #input>
            <div @click="isShowPopup(ycdd,'ycdd')">
              <span v-if="formData.ycdd.length > 0">
                {{ formData.ycdd.length > 1 ? formData.ycdd[0] + '...' : formData.ycdd[0] }}
              </span>
              <span class="cor-B3" v-else>
                请选择用餐地点
                <van-icon name="arrow" color="#8c8c8c"/>
              </span>
            </div>
            <van-popup position="bottom" v-model="ycdd.show">
              <van-nav-bar title="选择用餐地点" left-text="取消" right-text="确定" @click-left="ycdd.show = false" @click-right="ycdd.show = false"/>
              <van-checkbox-group v-model="formData.ycdd">
                <van-cell-group>
                  <van-cell v-for="(item, index) in ycdd.data" clickable :key="index" :title="item.dictLabel" @click.native="handlePopupCheckboxCellToggle('checkboxes',index)">
                    <template #right-icon>
                      <van-checkbox checked-color="#FFDA3E" :name="item.dictLabel" ref="checkboxes"/>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'dclx'" v-model="formData.dclx" center input-align="right" :required="isRequired('dclx')" name="dclx" :rules="getRules('dclx')" label="订餐类型" placeholder="订餐类型">
          <template #input>
            <view-item v-if="isDisabled('dclx')" :value="formData.dclx" placeholder="请选择订餐类型"/>
            <van-radio-group v-else v-model="formData.dclx" direction="horizontal">
              <van-radio name="公餐">公餐</van-radio>
              <van-radio name="私餐">私餐</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-f-show="'ycrs'" v-model="formData.ycrs" :readonly="isDisabled('ycrs')" type="number" :required="isRequired('ycrs')" :rules="getRules('ycrs')" name="ycrs" maxlength="50" autosize label="用餐人数" placeholder="请输入用餐人数" input-align="right"/>
        <van-field v-if="formData.dclx === '公餐'" v-f-show="'ssdw'" input-align="right" name="ssdw" :required="isRequired('ssdw')" :value="formData.ssdw" label="部门" :rules="getRules('ssdw')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssdw,'ssdw')" :value="formData.ssdw" placeholder="请选择部门"/>
            <van-popup v-model="ssdw.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssdw.show = false" @click-right="popupSubmit('ssdw',{label:'label',value:'value'})"/>
              <van-search v-model="ssdw.filterText" @input="pickerSearch($event,ssdw,'label')" clearable shape="round"/>
              <van-picker ref="ssdw" value-key="label" :columns="ssdw.filteredData" @cancel="ssdw.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-if="formData.dclx === '公餐'" v-f-show="'ssxm'" input-align="right" name="ssxm" :required="isRequired('ssxm')" :value="formData.ssxm" :rules="getRules('ssxm')" label="所属项目" placeholder="请选择项目">
          <template #input>
            <view-item @click.native="isShowPopup(ssxm,'ssxm')" :value="formData.ssxm" placeholder="请选择项目"/>
            <van-popup v-model="ssxm.show" position="bottom">
              <van-nav-bar title="选择项目" left-text="取消" right-text="确定" @click-left="ssxm.show = false" @click-right="popupSubmitSsxm('ssxm',{label:'projectName',value:'projectId'})"/>
              <van-search v-model="ssxm.filterText" @input="pickerSearch($event,ssxm,'projectName')" clearable shape="round"/>

              <van-picker :duration="0" ref="ssxm" value-key="projectName" :columns="ssxm.filteredData" @cancel="ssxm.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'ycbz'" input-align="right" name="ycbz" :required="isRequired('ycbz')" :value="formData.ycbz" label="用餐标准" :rules="getRules('ycbz')" placeholder="请选择用餐标准">
          <template #input>
            <view-item @click.native="isShowPopup(ycbz,'ycbz')" :value="formData.ycbz" placeholder="请选择用餐标准"/>
            <van-popup v-model="ycbz.show" position="bottom">
              <van-nav-bar title="选择用餐标准" left-text="取消" right-text="确定" @click-left="ycbz.show = false" @click-right="popupSubmit('ycbz')"/>
              <van-search v-model="ycbz.filterText" @input="pickerSearch($event,ycbz,'label')" clearable shape="round"/>
              <van-picker ref="ycbz" value-key="label" :columns="ycbz.filteredData" @cancel="ycbz.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'csjb'" input-align="right" name="csjb" :required="isRequired('csjb')" :value="formData.csjb" label="茶水级别" :rules="getRules('csjb')" placeholder="请选择茶水级别">
          <template #input>
            <view-item @click.native="isShowPopup(csjb,'csjb')" :value="formData.csjb" placeholder="请选择茶水级别"/>
            <van-popup v-model="csjb.show" position="bottom">
              <van-nav-bar title="选择茶水级别" left-text="取消" right-text="确定" @click-left="csjb.show = false" @click-right="popupSubmit('csjb')"/>
              <van-search v-model="csjb.filterText" @input="pickerSearch($event,csjb,'label')" clearable shape="round"/>
              <van-picker ref="csjb" value-key="label" :columns="csjb.filteredData" @cancel="csjb.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-if="formData.dclx === '公餐'" v-f-show="'sy'" v-model="formData.sy" :readonly="isDisabled('sy')" :required="isRequired('sy')" name="sy" :rules="getRules('sy')" type="textarea" maxlength="200" rows="3" autosize label="事由" show-word-limit placeholder="请输入事由" input-align="right"/>
        <van-field v-f-show="'dcbz'" v-model="formData.dcbz" :readonly="isDisabled('dcbz')" :required="isRequired('dcbz')" name="dcbz" :rules="getRules('dcbz')" type="textarea" maxlength="200" rows="3" autosize label="备注" show-word-limit placeholder="请输入备注" input-align="right"/>
        <van-field v-f-show="'field1638593529445'" class="fileValueBox" :value.prop="formData.field1638593529445" input-align="right" name="field1638593529445" :required="isRequired('field1638593529445')" :rules="getRules('field1638593529445')" label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('field1638593529445')" :files="formData.field1638593529445" @success="uploadSuccess" module-type="flow"
              @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','field1638593529445')"></uploadFiles>
          </template>
        </van-field>
        <van-field v-f-show="'xfzje'" v-model="formData.xfzje" :readonly="isDisabled('xfzje')" type="number" :required="isRequired('xfzje')" :rules="getRules('xfzje')" name="xfzje" maxlength="50" autosize label="消费总金额" placeholder="请输入消费总金额" input-align="right"/>
        <van-field v-f-show="'sszje'" v-model="formData.sszje" :readonly="isDisabled('sszje')" type="number" :required="isRequired('sszje')" :rules="getRules('sszje')" name="sszje" maxlength="50" autosize label="实收总金额" placeholder="请输入实收总金额" input-align="right"/>
        <van-field v-f-show="'xfmxfj'" class="fileValueBox"  :value.prop="formData.xfmxfj" input-align="right" name="xfmxfj" :required="isRequired('xfmxfj')" :rules="getRules('xfmxfj')" label="消费明细附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('xfmxfj')" :files="formData.xfmxfj" @success="xfmxfjUploadSuccess"
             @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','xfmxfj')"
             module-type="flow"></uploadFiles>
          </template>
        </van-field>

      </van-cell-group>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class="m-t-20" :flowTraceList="flowTrace" :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="m-t-20" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false" @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable shape="round"/>
      <div style="overflow-y: auto" class="h-vh-50">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid" check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node show-checkbox/>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getDeptUserTreeAll, getCurrentUserDept, selectMyProjectList, getUser} from '@/api/user.js'
import {getFormDataByInstanceId, getFoodOrderStat} from "@/api/flow";
import {getDictDataByType} from '@/api/dict'
import cache from "@/plugins/cache";
import mixin from '@/mixin/flow'
import moment from "moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";

export default {
  components: {uploadFiles, bottomBar, flowTrace, approver},
  mixins: [mixin,fileMixins],
  data() {
    return {
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      // 所属项目
      ssxm: {
        data: [],
        show: false,
        filteredData: [],
        filterText: '',
      },
      ycbz: {
        data: ['高', '中', '低'],
        show: false,
        filteredData: ['高', '中', '低'],
        filterText: '',
      },
      // 所属部门
      ssdw: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      // 茶水级别
      csjb: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      ycrq: {
        minDate: '',
        maxDate: '',
        show: false
      },
      ycdd: {
        show: false,
        data: []
      },
      formData: {
        flowNo: '',
        ycrq: '', // 用餐日期
        yclx: '午餐', // 用餐类型 默认午餐
        ycdd: [], // 用餐地点
        lxfs: '', // 联系方式
        dclx: '公餐', // 订餐类型
        ssdw: '', // 所属公司
        ycrs: '', // 用餐人数
        ycbz: '', // 用餐标准
        dcbz: '', // 特殊说明
        xfmxfj: [], // 消费明细附件
        dcr: '', // 订餐人
        sqr: '', // 申请人
        ssxm: '', // 所属项目
        csjb: '',// 茶水级别
        sy: '',
        field1638593529445: [],
        xfzje: '', // 消费总金额
        sszje: '',// 实收总金额
      },
      rules: {}
    }
  },
  created() {
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          console.log('重新发起拿回来数据', this.formData)

          this.selectMyProjectList(this.formData.dcr)
          this.getCurrentUserDept(this.formData.dcr)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.selectMyProjectList(this.formData.dcr)
        this.getCurrentUserDept(this.formData.dcr)
        this.$loading.hide()
      })
    } else { // 新增时
      // 新增时调用
      this.getFormInfo({templateId: this.templateId, groupId: this.groupId}).then(res => {
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.formData.sqr = currentUserInfo.userId
      this.formData.bxry = currentUserInfo.userId
      this.formData.lxfs = currentUserInfo.phonenumber
      this.selectMyProjectList(currentUserInfo)
      this.getCurrentUserDept(currentUserInfo)
    }
  },
  watch: {
    'formData.dclx'() {
      this.$refs.approver.startProcess()
    }
  },
  methods: {
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
      // 茶水级别
      getDictDataByType('food_level').then(res => {
        this.csjb.data = res.data.map(item => {
          return {
            label: item.dictLabel,
          }
        })
        this.csjb.filteredData = this.csjb.data
      })

      getDictDataByType('food_place').then(res => {
        this.ycdd.data = res.data
      })


      const today = moment().toDate()
      const nextMonth = moment().add(1, 'months').toDate()
      this.ycrq.minDate = today
      this.ycrq.maxDate = nextMonth
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.field1638593529445 = fileList
    },
    xfmxfjUploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.xfmxfj = fileList
    },


    setFormInfo(data) {
      Object.assign(this.formData, data)
      this.$refs.ycrq.reset(moment(data.ycrq).isValid() ? moment(data.ycrq).toDate() : new Date())
    },
    // 用餐日期
    ycrqConfirm(date) {
      this.formData.ycrq = moment(date).format('YYYY-MM-DD')
      this.ycrq.show = false
    },
    // 订餐人弹窗
    handlePopupSubmit() {
      if (this.$refs.tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一人', position: 'bottom'})
        return
      }
      this.formData.dcr = this.$refs.tree.getCheckedNodes()[0].id
      // 切换人部门列表跟着换
      this.getCurrentUserDept(this.$refs.tree.getCheckedNodes()[0])
      // 切换人 项目列表跟着换
      this.selectMyProjectList(this.$refs.tree.getCheckedNodes()[0])
      // 切换人获取手机号码
      this.getUser(this.$refs.tree.getCheckedNodes()[0].id)
      this.formData.ssdw = ''
      this.formData.ssxm = ''
      this.deptUserTreeAll.show = false
    },
    getUser(userId) {
      return new Promise(resolve => {
        getUser({userId}).then(res => {
          console.log(res.data.phonenumber)
          this.formData.lxfs = res.data.phonenumber
          resolve(res)
        })
      })
    },


    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssdw.data = res.data
          // 搜索过滤
          this.ssdw.filteredData = this.ssdw.data
          resolve(res.data)
        })
      })
    },
    // 获取人员所属项目列表
    selectMyProjectList(user) {
      return new Promise(resolve => {
        selectMyProjectList({projectMember: user.id || user.userId}).then(res => {
          this.ssxm.data = res.rows
          this.ssxm.filteredData = res.rows
          resolve(res.rows)
        })
      })
    },

  }
}

</script>


